import { Grid }  from '@mui/material';
import styled    from 'styled-components';
import { theme } from '../../../styles';

export const PageBody = styled.div`&& {
  padding: 24px 16px 45px !important;
  margin: 0 -16px -45px !important;
  background-color: ${ theme.colors.lightGrey };
  
  ${ ({ theme: { breakpoints } }) => breakpoints.up('sm') } {
    padding: 32px 32px 45px !important;
    margin: 0px -32px -45px !important;
  }
}`;

export const FullWidthGrid = styled(Grid)`
  margin: 0 -27px;
  width: calc(100% + 44px) !important;
  
  ${ ({ theme: { breakpoints } }) => breakpoints.up('sm') } {
    margin: 0 -32px;
    width: calc(100% + 64px) !important;
  }
}`;
